import { missionRunStart } from "arcjs/protocols/control";
import { NavigationServices } from "arcjs/services/navigation";
import ARCCard from "components/ARC/ARCCard";
import FunctionalButton from "components/layout/FunctionalButton";
import SimpleDropDownMenu from "components/layout/dropdowns/SimpleDropDownMenu";
import { ARC } from "providers/MultiARCsControlProvider";
import { useCallback, useEffect, useState } from "react";
import { useFleet } from "providers/FleetProvider";

type MissionSelectorProps = {
    assignee: ARC;
    mapId: string;
    onAssigned: (arcSerial: string, missionId: string) => void;
} & React.HTMLProps<HTMLDivElement>;

const MissionSelector = ({
    className,
    mapId,
    assignee,
    onAssigned,
    ...props
}: MissionSelectorProps) => {
    const { arcStatuses } = useFleet();
    const [missions, setMissions] =
        useState<Awaited<ReturnType<NavigationServices["getMissions"]>>>();
    const services = assignee.services;
    const control = assignee.control;
    const serial = assignee.serialNumber;
    useEffect(() => {
        console.log("assignee:", assignee);
    }, [assignee]);
    useEffect(() => {
        services.navigationService
            .getMissions()
            .then((res) => {
                console.log("getMissions result:", res);
                setMissions(res);
            })
            .catch((err) => {
                console.log("getMissions encountered an error:", err);
            });
    }, [services, setMissions, mapId]);

    const [selectedMission, setSelectedMission] = useState<string>("");

    const assignSelectedMission = useCallback(() => {
        console.log(`arc with serial ${serial} was assigned mission with id ${selectedMission}`);
        control.send(...missionRunStart(selectedMission, null));
        onAssigned(serial, selectedMission);
    }, [serial, control, onAssigned, selectedMission]);

    return (
        <div className={`flex flex-col gap-4 ${className}`} {...props}>
            <ARCCard arc={assignee} arcStatus={arcStatuses[assignee.serialNumber]} action={null} />
            <div className="flex flex-col gap-2">
                <h4>Select mission</h4>
                {missions ? (
                    <SimpleDropDownMenu
                        value={selectedMission}
                        dropDownOptions={missions.map(({ id, name }) => ({ value: id, name }))}
                        onSelect={({ value }) => setSelectedMission(value)}
                    />
                ) : (
                    "Loading"
                )}
            </div>
            <FunctionalButton
                className="w-full rounded-r10 bg-primary p-2 hover:bg-secondary disabled:bg-black40"
                title="Assign"
                disabled={!selectedMission}
                onClick={() => assignSelectedMission()}
            />
        </div>
    );
};

export default MissionSelector;
